import GoogleLogo from '@/assets/google-logo.svg';


export default function ({ provider }) {
  console.log(provider);
  return (
    <button className="flex flex-row justify-between items-center shadow-sm p-2 w-full mb-2 cursor-pointer rounded hover:bg-gray-200 bg-gray-100">
      <div className="flex flex-row items-center">
        <img
          src={GoogleLogo.src}
          alt="GoogleLoginButton"
          width="35px"
          height="35px"
        />
        <div className={'ms-3'}>Log in with Google</div>
      </div>
      <i className="mio">arrow_forward_ios</i>
    </button>
  );
}
